import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
const REQUEST_STEPS: {
  n: string;
  text: React.ReactNode;
}[] = [{
  n: 'i',
  text: <>
        Escribe a{' '}
        <a href="mailto:sales@dermaclinicenter.com" data-id="element-241">
          sales@dermaclinicenter.com
        </a>{' '}
        desde la misma dirección con la que realizaste la compra.
      </>
}, {
  n: 'ii',
  text: <>
        Incluye el{' '}
        <strong className="legal-key" data-id="element-242">número de orden de Shopify</strong> dentro
        de los <strong className="legal-key" data-id="element-243">14 días</strong> posteriores a la
        compra.
      </>
}, {
  n: 'iii',
  text: <>
        Eso es todo.{' '}
        <strong className="legal-key" data-id="element-244">
          No necesitas justificar tu solicitud.
        </strong>
      </>
}];
export function Refund() {
  return <LegalLayout title="Política de Reembolso" updated="17 de mayo, 2026" data-id="element-245">
      <section className="legal-section legal-section--lead" data-id="element-246">
        <h2 data-id="element-247">Garantía de 14 días</h2>
        <p className="legal-lead" data-id="element-248">
          A.R.M.O.N.Y. está respaldado por una garantía de{' '}
          <strong className="legal-key" data-id="element-249">catorce (14) días naturales</strong>{' '}
          contados desde la fecha de compra.
        </p>
        <p data-id="element-250">
          Si en ese plazo el material no te ha aportado claridad real para tu
          decisión, te devolvemos el{' '}
          <strong className="legal-key" data-id="element-251">100% del importe pagado</strong> — sin
          preguntas, sin formularios largos, sin justificación.
        </p>
      </section>

      <section className="legal-section" data-id="element-252">
        <h2 data-id="element-253">Cómo solicitarlo</h2>
        <ol className="legal-steps" data-id="element-254">
          {REQUEST_STEPS.map(step => <li key={step.n} className="legal-step" data-id="element-255">
              <span className="legal-step-num" aria-hidden="true" data-id="element-256">
                {step.n}
              </span>
              <p className="legal-step-text" data-id="element-257">{step.text}</p>
            </li>)}
        </ol>
      </section>

      <section className="legal-section" data-id="element-258">
        <h2 data-id="element-259">Plazo de procesamiento</h2>
        <p data-id="element-260">
          Procesamos cada solicitud dentro de los{' '}
          <strong className="legal-key" data-id="element-261">tres (3) días hábiles</strong>{' '}
          siguientes a su recepción. El reembolso se emite al mismo método de
          pago utilizado en la compra original; el tiempo de aparición en tu
          cuenta depende de tu emisor (entre 3 y 10 días hábiles, típicamente).
        </p>
      </section>

      <section className="legal-section" data-id="element-262">
        <h2 data-id="element-263">Después de los 14 días</h2>
        <p data-id="element-264">
          Pasada la ventana de garantía no se procesan reembolsos. Esta política
          aplica únicamente al bundle digital A.R.M.O.N.Y. y no afecta consultas
          presenciales, procedimientos, ni otros servicios prestados por
          Dermaclinic.
        </p>
      </section>

      <section className="legal-section" data-id="element-265">
        <h2 data-id="element-266">Contacto</h2>
        <p data-id="element-267">
          Dudas sobre esta política:{' '}
          <a href="mailto:sales@dermaclinicenter.com" data-id="element-268">
            sales@dermaclinicenter.com
          </a>
        </p>
      </section>
    </LegalLayout>;
}